"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkePage = exports.IkePageName = void 0;
var tslib_1 = require("tslib");
var mithril_component_1 = require("../components/mithril.component");
var IkePageName;
(function (IkePageName) {
    // Internal Pages
    IkePageName["root"] = "root";
    IkePageName["login"] = "auth.login";
    IkePageName["logout"] = "auth.logout";
    IkePageName["map"] = "map";
    IkePageName["jobList"] = "job.list";
    IkePageName["formList"] = "form.list";
    IkePageName["formNew"] = "form.new";
    IkePageName["formEdit"] = "form.edit";
    IkePageName["accountList"] = "account.list";
    IkePageName["collectionImport"] = "collection.import";
    IkePageName["collectionMeasure"] = "collection.measure";
    IkePageName["collectionReport"] = "collection.report";
    IkePageName["collectionHistory"] = "collection.history";
    IkePageName["forgotPassword"] = "forgot.password";
    IkePageName["acceptInvite"] = "accept.invite";
    IkePageName["pageMissing"] = "status.404";
    IkePageName["orgSearch"] = "org.search";
    IkePageName["dashboardPolestatus"] = "dashboard.polestatus";
    IkePageName["dashboardPoleloading"] = "dashboard.poleloading";
    IkePageName["dashboardMenu"] = "dashboard.menu";
    IkePageName["topologicalEditor"] = "topological.editor";
    IkePageName["userSSOMigrate"] = "user.sso.migrate";
    // External Pages
    IkePageName["genericExternal"] = "generic.external";
    IkePageName["comedEsri"] = "comed.esri";
})(IkePageName || (exports.IkePageName = IkePageName = {}));
var IkePage = /** @class */ (function (_super) {
    tslib_1.__extends(IkePage, _super);
    function IkePage(config) {
        var _this = _super.call(this) || this;
        _this.config = config;
        _this.setConfigDefaults();
        return _this;
    }
    IkePage.prototype.setConfigDefaults = function () {
        this.config.layout = tslib_1.__assign({ banner: true, nav: true }, this.config.layout);
        if (this.config.supportDepartmentChange == null) {
            this.config.supportDepartmentChange = false;
        }
    };
    /**
     * This will be called before the loading of the next page.
     */
    IkePage.prototype.unload = function () {
        this.onBeforeUnload();
        this.onRemove();
    };
    /**
     * This _may_ be implemented by any IkePage to handle their own unloading function.
     * For example, removing any edit state that the page is storing.
     */
    IkePage.prototype.onBeforeUnload = function () {
        return;
    };
    return IkePage;
}(mithril_component_1.IMithrilStateComponent));
exports.IkePage = IkePage;
//# sourceMappingURL=page.js.map